import $ from 'jquery';
import design from '../models/design';

let pendingRequest;

const updateDesign = (context, payload, done) => {
    context.dispatch('UPDATE_DESIGN_START', payload);

    if (pendingRequest) {
        pendingRequest.abort();
    }

    // FIXME: Convert to superagent once endpoints take csrf token embedded urls
    pendingRequest = $.ajax({
        url: payload.design.links.self,
        method: 'put',
        data: payload.data,
    });

    pendingRequest.done(function(res) {
        context.dispatch('UPDATE_DESIGN_SUCCESS', design.fromJSON(res));

        // notify flight component to refresh entries
        $('body').trigger('uiDesignsRefreshRequested');

        done();
    });

    pendingRequest.fail(function(xhr, txtStatus) {
        if (txtStatus !== 'abort') {
            context.dispatch('UPDATE_DESIGN_FAILED', { design: { ...payload.design } });
        }

        done();
    });
};

export default updateDesign;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/actions/update-design.js